import HTTPService from '../HTTPService'

class Company {
  getCompany (companySlug) {
    return HTTPService.get(`company/${companySlug}`)
  }

  updateCompany (companySlug, payload) {
    return HTTPService.put(`company/${companySlug}`, {
      timezone: payload.timezone,
      settings: {
        name: payload.name,
        city: payload.city
      }
    })
  }

  getDaysOfWeek (companySlug) {
    return HTTPService.get(`company/${companySlug}/dow`)
  }

  updateDayOfWeek (companySlug, dayOfWeek, payload) {
    return HTTPService.put(`company/${companySlug}/dow/${dayOfWeek}`, {
      is_working_day: payload.is_working_day,
      starts_at: payload.starts_at,
      ends_at: payload.ends_at
    })
  }
}

export default new Company()
